<script setup>
import { useSlots } from 'vue'

const slots = useSlots()
</script>

<template>
  <div>
    <div class="challenge-notice">
      <div class="content">
        <div class="description">
          【挑战须知】欢迎您踏入病例实战海洋，在此诚邀广大医生围绕具体病例实战开展深入学习讨论。我们每一次学习都是对自我提升的宝贵投资。为了确保您的学习之旅既充实又高效，我们特别制定了以下挑战须知，旨在引导您以"严谨、创新、实践和求真"的态度深入探索医学的奥秘。
        </div>
        <ol class="rules">
          <li>严谨为先，求真为本</li>
          <li>创新引领，探索无限</li>
          <li>实践出真知，学以致用</li>
          <li>求真务实，尊重生命</li>
        </ol>
      </div>
      <div class="progress">
        <slot name="progress" />
      </div>
    </div>
    <div v-if="slots['exams']" class="challenge-notice">
      <slot name="exams" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.challenge-notice {
  position: relative;
  padding: 10px;
  background-color: #fff;
  font-size: 14px;
  color: #1e1e1e;
  .description {
    line-height: 23px;
    margin-bottom: 10px;
  }
  + .challenge-notice {
    margin-top: 10px;
  }
}
.rules {
  counter-reset: my-counter;
  line-height: 26px;
  li {
    counter-increment: my-counter;
    &::before {
      content: counter(my-counter) "、";
    }
  }
}
.progress {
  margin-top: 10px;
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
.lock-icon {
  width: 48px;
  height: 48px;
}
</style>
